import classes from './Header.module.css';
import { Fragment, useContext, useState, useEffect, useRef } from "react";
import { AuthContext } from '../context/AuthContext';
import HeaderDropdown from './Header_dropdown';
import HeaderRegister from './Header_register';
import HeaderSearchbar from './Header_searchbar';
import umiunilogo from '../../umiunilogo.jpg'
import { useNavigate } from 'react-router-dom';
import HeaderDonateButton from './Header_donatebutton';
import HeaderTopUpButton from './Header_topupbutton';
import HeaderSchoolDropdown from './Header_schooldropdown';
import HeaderChatRoomButton from './Header_chatroombutton';
import HeaderCheckInButton from './Header_checkinbutton';
import { IoMdMenu } from 'react-icons/io';
import style from "./header_searchbar.module.css";
import { TbLayoutSidebarRightCollapseFilled } from "react-icons/tb";

const Header = (props) => {
    const { auth } = useContext(AuthContext);

    const [isMobile, setIsMobile] = useState(false);
    const [secondHeader, setSecondHeader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isCollapsed, setIsCollapsed] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const extraMenuOptions = [
        { value: "Alumni", label: "Alumni"},
        { value: "Car", label: "Cars" },
        { value: "Event", label: "Events" },
        { value: "Rental", label: "Rentals" },
        { value: "Restaurant", label: "Restaurants" },
        { value: "UsedItem", label: "UsedItems" }
    ];

    const handleExternalLink = (url) => {
        window.open(url, "_blank");
    };

    const redirectSearch = (type) => {
        switch(type) {
            case "Alumni":
                handleExternalLink("https://alumni.umiuni.com/")
                break;
            case "Car":
                navigate("/cars");
                break;
            case "Event":
                navigate("/events");
                break;
            case "Rental":
                navigate("/rentals");
                break;
            case "Restaurant":
                navigate("restaurants");
                break;
            case "UsedItem":
                navigate("/used");
                break;
        }
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleDropdownOptionClick = (optionValue) => {
        setSelectedOption(optionValue);
        setIsOpen(false);
        redirectSearch(optionValue);
    };

    const renderDropdownOptions = (options) => {
        return (
            <div className={classes.dropdown}>
                <button onClick={toggleDropdown} className={style.searchButton}>
                    <IoMdMenu className='icon' style={{ fontSize: "2rem" }} />
                </button>
                {isOpen && (
                    <div className={`${classes.dropdownContent} ${classes.show}`}>
                        {options.map(option => (
                            <div key={option.value} onClick={() => handleDropdownOptionClick(option.value)}>
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const handleHomePage = () => {
        navigate('/');
    }

    useEffect(() => {
        const checkWindowSize = () => {
            setIsMobile(window.innerWidth <= 768);
            setSecondHeader(window.innerWidth <= 1138);
        };
        checkWindowSize();
        document.addEventListener('click', handleClickOutside);
        window.addEventListener("resize", checkWindowSize);

        return () => {
            window.removeEventListener("resize", checkWindowSize);
            document.removeEventListener('click', handleClickOutside);
        };
    }, [])

    return (
        <Fragment>
            <div className={classes.headerWrapper} ref={dropdownRef}>
                <header className={`${classes.header} ${isMobile || secondHeader ? classes.expandedHeader : ''} ${isCollapsed ? classes.collapsed : ''}`}>
                    <div>
                        <img src={umiunilogo} className={classes.logo} onClick={handleHomePage} />
                    </div>
                    <div className={classes.headerButton}>
                        <HeaderChatRoomButton />
                        <HeaderDonateButton />
                        <HeaderTopUpButton />
                        <HeaderCheckInButton />
                        <>
                            {renderDropdownOptions(extraMenuOptions)}
                        </>
                    </div>
                    {auth.userid && auth.vip && <span className={classes.vipBadge}>VIP {auth.vip}</span>}
                    <div className={classes.user}>
                        {auth.userid ? (
                            <div className={classes.userContainer}>
                                <HeaderDropdown />
                            </div>
                        ) : (
                            <HeaderRegister />
                        )}
                    </div>
                </header>

                <button
                    className={`${classes.collapseTab} ${isCollapsed ? classes.flipped : ''}`}
                    onClick={() => setIsCollapsed(prev => !prev)}
                    aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                >
                    <TbLayoutSidebarRightCollapseFilled />
                </button>
            </div>
        </Fragment>
    );
};

export default Header;